/* eslint-disable react-hooks/exhaustive-deps */
import { Layout, Modal, Tabs } from 'antd';
import queryString from 'query-string';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import OfflineAndRtmpCameraComponent from './AddCamera/OfflineCamera';
import RTSPlinkAddCameraComponent from './AddCamera/RTSPlinkAddCamera';
import AddDeviceCamera from './AddDeviceCamera';
import ListCameraComponent from './ListCamera';
import StorageVideoComponent from './StorageVideo';
import UpdateCameraComponent from './UpdateCamera';
import UpdateStreamComponent from './UpdateStream';
import './index.scss';

const { Sider } = Layout;
const { TabPane } = Tabs;

const CameraPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const {
    isAuth,
    cameras: pageCameras,
    updateDevice,
    namespace,
    addDeviceData,
    checkExternalDevice,
    activeDeviceData,
  } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [cameras, setCameras] = useState();
  const [total, setTotal] = useState(0);
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [selectCamera, setSelectCamera] = useState();
  const [visibleEdit, setVisibleEdit] = useState();
  const [visibleStream, setVisibleStream] = useState();

  const [visibleAddCamera, setVisibleAddCamera] = useState(false);
  const [addDeviceReturn, setAddDeviceReturn] = useState(addDeviceData);
  const [checkExternalDeviceReturn, setCheckExternalDeviceReturn] = useState();
  const [activeDeviceReturn, setActiveDeviceReturn] =
    useState(activeDeviceData);
  const [dataSearchCamera, setDataSearchCamera] = useState();
  const [key, setKey] = useState(Math.random());
  const [nameCameraSearch, setNameCameraSearch] = useState();
  const [keyTab, setKeyTab] = useState('1');

  useEffect(() => {
    return () => {
      setAddDeviceReturn(null);
      setCheckExternalDeviceReturn(null);
      setActiveDeviceReturn(null);
    };
  }, []);

  useEffect(() => {
    if (pageCameras) {
      setCameras(pageCameras.data);
      setTotal(pageCameras.totalSize);
      if (pageCameras.data?.length === 1) {
        setSelectCamera(pageCameras.data?.[0]);
      }
    }
  }, [pageCameras]);

  useEffect(() => {
    const { redirect, camera } = queryString.parse(location.search);
    const { key } = queryString.parse(location.hash);
    if (
      redirect &&
      key &&
      cameras &&
      cameras.some((child) => child.serial === key)
    ) {
      history.push('#storage');
      setNameCameraSearch(camera);
      return setSelectCamera(
        cameras && cameras.filter((camera) => camera.serial === key)[0]
      );
    }
  }, [cameras, history, location]);

  const [updateReturn, setUpdateReturn] = useState();
  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setUpdateReturn(updateDevice);
      if (page && isAuth === 1 && pageSize && namespace) {
        getDeviceByPage(page - 1, pageSize);
      }
    }
  }, [updateDevice]);
  useEffect(() => {
    if (
      visibleEdit &&
      updateReturn &&
      updateReturn.serial === visibleEdit.serial
    ) {
      if (updateReturn.isSuccess) {
        setCameras((state) =>
          state.map((camera) => {
            if (camera.serial !== updateReturn.data.serial) return camera;
            return { ...camera, ...updateReturn.data };
          })
        );
        setUpdateReturn(null);
        setVisibleEdit(null);
      }
    }
  }, [updateReturn, visibleEdit]);

  useEffect(() => {
    setAddDeviceReturn(addDeviceData);
  }, [addDeviceData]);

  useEffect(() => {
    setCheckExternalDeviceReturn(checkExternalDevice);
  }, [checkExternalDevice]);

  useEffect(() => {
    setActiveDeviceReturn(activeDeviceData);
  }, [activeDeviceData]);

  const onUpdateDevice = useCallback(
    (data) => {
      if (data && visibleEdit) {
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify({ ...data, namespace }),
        };

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, visibleEdit]
  );

  const onUpdateCamera = useCallback(
    (data, requestId) => {
      if (data) {
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId,
          body: JSON.stringify({
            ...data,
            namespace,
          }),
        };

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  const getDeviceByPage = useCallback(
    (page, size, dataSearch) => {
      let data = {
        namespace,
        deviceType: 'camera',
        timeRequest: requestId,
        page,
        size,
      };
      if (dataSearch) {
        data.name = dataSearch;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, requestId]
  );
  useEffect(() => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize, dataSearchCamera);
    }
  }, [getDeviceByPage, isAuth, namespace, page, pageSize]);

  const onDeviceByPage = () => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize);
    }
  };

  const onDeviceSelect = () => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize + 10);
    }
  };

  const onRequireActiveDevice = useCallback(
    (serial) => {
      if (serial && serial.length > 0) {
        let data = {
          serial: serial.trim(),
          namespace,
        };

        let dataObj = {
          appServiceType: SERVICE.REQUIRE_ACTIVE_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  const onCheckExternalDevice = useCallback(
    (serial) => {
      if (serial && serial.length > 0) {
        let data = {
          serial: serial.trim(),
          namespace,
          deviceType: 'camera',
          extraInfo: {},
        };

        let dataObj = {
          appServiceType: SERVICE.CHECK_EXTERNAL_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  const onAddDevice = useCallback(
    (serial, activationCode) => {
      if (
        serial &&
        serial.length > 0 &&
        activationCode &&
        activationCode.length > 0
      ) {
        let data = {
          serial,
          activationCode,
          namespace,
        };

        let dataObj = {
          appServiceType: SERVICE.ADD_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  const onAddCamera = useCallback(
    (serial, name, deviceSerial, typeCamera) => {
      if (serial && serial.length > 0 && name && name.length > 0) {
        let data = {
          namespace,
          serial: deviceSerial,
          deviceType: 'camera',
          extraInfo: {
            typeCamera: typeCamera, //'offline_camera',
            name: name.trim(),
            factorySerial: serial,
          },
        };

        let dataObj = {
          appServiceType: SERVICE.REQUEST_ADD_EXTERNAL_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  const handleChangeTab = (value) => {
    setKeyTab(value);
  };

  return (
    <div className="camera-management-component">
      <Modal
        visible={visibleAddCamera}
        onCancel={() => {
          setVisibleAddCamera(false);
          setKey(Math.random());
        }}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {visibleAddCamera && (
          <div className="add-camera-component">
            <Tabs key={key} defaultActiveKey="1" onChange={handleChangeTab}>
              <TabPane tab={t('Camera 3/4G')} key="1">
                {keyTab === '1' && (
                  <AddDeviceCamera
                    dispatch={dispatch}
                    addDeviceReturn={addDeviceReturn}
                    activeDeviceReturn={activeDeviceReturn}
                    onRequireActiveDevice={onRequireActiveDevice}
                    onAddDevice={onAddDevice}
                    onUpdate={onUpdateCamera}
                    namespace={namespace}
                    handleAddSuccessful={() => {
                      setVisibleAddCamera(false);
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                  />
                )}
              </TabPane>
              <TabPane tab={t('RTSP Link')} key="2">
                {keyTab === '2' && (
                  <RTSPlinkAddCameraComponent
                    onDone={() => {
                      setVisibleAddCamera(false);
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                    gatewaySerial=""
                  />
                )}
              </TabPane>
              <TabPane tab={t('Offline Camera')} key="3">
                {keyTab === '3' && (
                  <OfflineAndRtmpCameraComponent
                    typeCamera="offline_camera"
                    dispatch={dispatch}
                    checkDeviceReturn={checkExternalDeviceReturn}
                    activeDeviceReturn={activeDeviceReturn}
                    onCheckExternalDevice={onCheckExternalDevice}
                    onAddCamera={onAddCamera}
                    onUpdate={onUpdateCamera}
                    handleAddSuccessful={() => {
                      setVisibleAddCamera(false);
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                  />
                )}
              </TabPane>
              <TabPane tab={t('RTMP Camera')} key="4">
                {keyTab === '4' && (
                  <OfflineAndRtmpCameraComponent
                    typeCamera="rtmp_camera"
                    dispatch={dispatch}
                    checkDeviceReturn={checkExternalDeviceReturn}
                    activeDeviceReturn={activeDeviceReturn}
                    onCheckExternalDevice={onCheckExternalDevice}
                    onAddCamera={onAddCamera}
                    onUpdate={onUpdateCamera}
                    handleAddSuccessful={() => {
                      setVisibleAddCamera(false);
                      setKey(Math.random());
                      setKeyTab('1');
                      return getDeviceByPage(page - 1, pageSize);
                    }}
                  />
                )}
              </TabPane>
            </Tabs>
          </div>
        )}
      </Modal>
      <Modal
        title={t('Update camera')}
        visible={!!visibleEdit}
        onCancel={() => setVisibleEdit(null)}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {!!visibleEdit && (
          <UpdateCameraComponent
            updateDataReturn={updateReturn}
            onCancel={() => setVisibleEdit(null)}
            onUpdate={onUpdateDevice}
            data={visibleEdit}
          />
        )}
      </Modal>
      <Modal
        title={t('Update stream')}
        visible={!!visibleStream}
        onCancel={() => setVisibleStream(null)}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <UpdateStreamComponent
          onCancel={() => setVisibleStream(null)}
          onUpdate={onUpdateDevice}
          data={visibleStream}
        />
      </Modal>
      <Layout>
        <Sider width={324}>
          <ListCameraComponent
            handleUpdateCamera={(camera) => setVisibleEdit(camera)}
            handleUpdateStream={(camera) => setVisibleStream(camera)}
            getDeviceByPage={getDeviceByPage}
            data={cameras}
            page={page}
            setPage={setPage}
            total={total}
            pageSize={pageSize}
            setPageSize={setPageSize}
            selectCamera={selectCamera}
            setSelect={setSelectCamera}
            onDeviceByPage={onDeviceByPage}
            setDataSearchCamera={setDataSearchCamera}
            nameCameraSearch={nameCameraSearch}
          />
        </Sider>
        <Layout style={{ padding: '0 8px' }}>
          <StorageVideoComponent
            dispatch={dispatch}
            setSelect={setSelectCamera}
            serial={selectCamera && selectCamera.serial}
            permission={selectCamera && selectCamera.permission}
            handleAddCamera={() => setVisibleAddCamera(true)}
            selectCamera={selectCamera}
          />
        </Layout>
      </Layout>
    </div>
  );
};

export default CameraPage;
